import baustein from "baustein";


export default baustein.register("profile-page", {
    init: function() {
        this.profileId = this.options.profileId;
    },

    setupEvents: function(add) {
        add("userFollow", this.onUserFollow);
        add("userUnfollow", this.onUserUnfollow);
    },

    onUserUnfollow: function(event) {
        const component = this.findComponent("profile-header-counters");
        if (component) {
            component.updateFollowCounter(event, this.profileId);
        }
    },

    onUserFollow: function(event) {
        const component = this.findComponent("profile-header-counters");
        if (component) {
            component.updateFollowCounter(event, this.profileId);
        }
    },
});
